import { Media } from "packages/dsaui/src/responsive";

export type ResponsiveMedia = typeof Media;

export const Desktop: ResponsiveMedia = (props) => (
  <Media {...props} greaterThanOrEqual="lg" />
);

export const TabletAndUp: ResponsiveMedia = (props) => (
  <Media {...props} greaterThanOrEqual="md" />
);

export const TabletAndDown: ResponsiveMedia = (props) => (
  <Media {...props} lessThan="lg" />
);

export const Tablet: ResponsiveMedia = (props) => <Media {...props} at="md" />;

export const MobileAndUp: ResponsiveMedia = (props) => (
  <Media {...props} greaterThanOrEqual="sm" />
);

export const Mobile: ResponsiveMedia = (props) => (
  <Media {...props} between={["xs", "m"]} />
);

export const PhonesOnly: ResponsiveMedia = (props) => <Media {...props} at="xs" />;
